import React, { useContext, useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Button } from 'primereact/button';

import Loader from '../../../Base/Components/Loader/Loader';
import Card from '../../../Base/Components/Card/Card';

import { borderColorCotton, borderColorSintetico, borderColorVentas, colorSintetico, datalabelsCantidadPersonas, datalabelsLine, datalabelsLineGerencia, datalabelsLineVentas, getScales, getTitle } from '../../../utils/KPIs/productionUtils';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import { getPersonalPorArea, getPersonalPorAreaGeneral } from '../../../API/RRHH/KPIs/HeadCountsRequtets';
import HeadCountScreen from './HeadCountScreen';
import './headCount.scss'
import { baseLang } from '../../../Base/Lang/BaseLang';
import { getLabel } from '../../../Base/Services/Language/LanguageService';

const PersonalPorArea = ({fecha, kpiGerencia, getDatos, setShowPersonal, altura }) => {


  const { config } = useContext(ConfigContext);

  const [loading, setLoading] = useState(false);
  const [chart, setChart] = useState({ data: {}, options: {} });
  const [data, setData] = useState({})
  const [char, setChar] = useState({})
  const [tot, setTot] = useState(null)
  const colorTitle = getTitle(config);
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  let Mes = fecha.toLocaleString('es-ES', { month: 'long' })
  const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);
  let totalPersonas

  const getInfo = async () => {
    setLoading(true);
    const tempoAnual = await getPersonalPorArea();
    const data = [...tempoAnual]

    const areasTotales = data.map(item => item?.Area);


    let anualValor = [];
    tempoAnual.forEach((item) => {
      anualValor.push(item.NoPersonas);
    });

    let maxValor = Math.max(...anualValor);

    const config = {
      type: 'bar'
    }
    setChart({
      data: {
        labels: areasTotales,
        datasets: [
          {
            ...config,
            label: 'No. Personas',
            backgroundColor: colorSintetico,
            borderColor: colorSintetico,
            data: anualValor,
            // fill: true,
          },
        ],
      },
      options: {
        interaction: {
          intersect: false,
          mode: 'index',
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          // datalabels: datalabelsCantidadPersonas,
          datalabels: {
            borderRadius: 4,
            align: 'end',
            anchor: 'end',
            borderWidth: 2,
            marginButtom: 10,
            color: colorTitle,
            padding: 6,
            offset: 5,
            font: {
              weight: 'bold',
              size: 11,
              color: colorTitle,
            },
        
            formatter: (value, context) => {
                if (value === 0 || value === null) {
                  return null
                }
                return value
            },
          },
          aspectRatio: 5 / 3,
          elements: {
            line: {
              fill: false,
              tension: 0.4
            }
          },
          legend: {
            position: 'bottom',
            labels: {
              color: colorTitle,
              font: {
                size: 11,
              },
            },
          },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    minRotation: 90,
                    maxRotation: 90,
                    color: colorTitle,
                    font: {
                      size:  12
                    },
                  }
            },
          y: {
            suggestedMax: maxValor + 10,
            ticks: {
              color: colorTitle,
              callback: (val) => {
                return val
                // return (val > 0 ? formatNumber(val).replace('.00', '') : '')
              }
            }
          }
        },

      }
    })
    setLoading(false);
  }


  // console.log(screenSize)

  const getInfoGeneral = async () => {
    setLoading(true);
    const t = await getPersonalPorAreaGeneral();
  
    const labels = t.map((item) => item.Clasificacion.trim()); // Usamos Clasificación para las etiquetas
    const data = t.map((item) => item.NoPersonas); // Usamos NoPersonas para los valores
  
    totalPersonas = data.reduce((acc, curr) => acc + curr, 0);
    setTot(totalPersonas)
    
    setData(t);
    setChar({
      labels: labels,
      datasets: [
        {
          label: "",
          backgroundColor: [borderColorCotton, borderColorSintetico, borderColorVentas], 
          data: data,
          color: "white",
        },
      ],
      plugins: {
        title: {
          display: false,
          text: "Personal Por Area",
          color: colorTitle,
        },
        legend: {
          display: false, // Mostramos la leyenda
          position: 'right', // Posicionamos la leyenda a la derecha
          labels: {
            boxWidth: 30, // Ancho del cuadro de color en la leyenda
            padding: 40, // Espacio entre la leyenda y el gráfico (ajustado a 40px para mayor separación)
            color: colorTitle, // Color del texto de la leyenda
          }
        },
        datalabels: {
          color: "white", // Color del texto dentro del gráfico
          font: {
            weight: "bold",
          },
          align: "center",
          // formatter: (value, context) => {
          //   return labels[context.dataIndex] + "\n" + value;
          // },
        },
        tooltip: {
          callbacks: {
            footer: (tooltipItems) => {
              totalPersonas = data.reduce((acc, curr) => acc + curr, 0);
              return "Total Personal: " + totalPersonas;
            },
          },
        },
      },
    });
    setLoading(false);
  };
  
  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
  
    window.addEventListener('resize', handleResize);
    
    // Cleanup function to remove the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  
  

  useEffect(() => {
    getInfo();
    getInfoGeneral()
  }, [])

  useEffect(() => {
    if (getDatos) {
      getInfo()
      getInfoGeneral()
    }
  }, [getDatos])



  return (

    <div className='hCount'>

      <Loader loading={loading} querySelector={'#resumenVentasAnual'} />

      <div className='personalArea'>
      <h6 className='bold' style={{ textAlign: 'center', fontSize: '0.85rem', fontWeight: 'bold' }}>
        {monthName} / {fecha.getFullYear()}
      </h6>

      <div className='d-flex' style={{justifyContent: "center"}}>
        <h6 className='bold' style={{ textAlign: 'center', fontSize: '0.85rem', fontWeight: 'bold' }}>
          Personal Total : 
        </h6>
        <h6 className='bold' style={{ textAlign: 'center', fontSize: '0.85rem', fontWeight: 'bold' }}>
          {tot}
        </h6>
      </div>
        <Card
          titulo={
            <div className='d-flex'>
              <h4 className='mt-2'>{getLabel(baseLang, "personalTotal", config.language)}</h4>
              {kpiGerencia &&
                <Button
                  className="p-button-text mx-2"
                  tooltip='No. Personas'
                  icon='pi pi-eye'
                  onClick={() => { setShowPersonal(true); }}
                />
              }
            </div>
        }
          contenido={
            <div className='mt-4' style={kpiGerencia ? { display: 'flex' } : {}}>
              <div className='col-12' style={{ flex: 1 }}>
                <Chart height={kpiGerencia ? '250px': '40vh'} width='100%' type='bar' data={chart.data} options={chart.options} plugins={[ChartDataLabels]}/>
              </div>
            </div>
          }
          />
      </div>

      <div className='headCountClass'>
        <HeadCountScreen kpiGerencia={false} fecha={fecha} buscar={getDatos} setShowPersonal={setShowPersonal}/>
      </div>

      <div className="headCountClass2">
          <Card
            titulo={
              <div className='d-flex'>
                <h4 className='mt-2'>{getLabel(baseLang, "personalTotalG", config.language)}</h4>
                {kpiGerencia &&
                  <Button
                    className="p-button-text mx-2"
                    tooltip='No. Personas'
                    icon='pi pi-eye'
                    onClick={() => { setShowPersonal(true); }}
                  />
                }
              </div>
            }
            contenido={
              <div className='d-flex' style={{ flexDirection: 'row', justifyContent: 'space-evenly' }}>
                <div  style={{ width: 150, height: 250, position: 'relative'}}>
                  <div className='chart'>
                    <Chart height={150} width={150} type="doughnut" data={char} options={char} plugins={[ChartDataLabels]} />
                  </div>
                  <div className='iconHeadCount'>
                    <i className="pi pi-users" style={{ 'fontSize': '4em' }}></i>
                  </div>
                </div>


                <div className='info mt-10'>
                  <div className="d-flex fila in">
                      <div className='col-4 mx-2 d-flex'>
                          <i className='ri-shopping-cart-2-line in' />
                          <div className='mx-2 mt-3'>
                            Ventas
                          </div>
                      </div>
                  </div>
                  <div className="d-flex fila out">
                      <div className='col-4 mx-2 d-flex'>
                          <i className='ri-account-circle-line out' />
                          <div className='mx-2 mt-3'>
                            Administración
                          </div>
                      </div>
                  </div>
                  <div className="d-flex fila pro">
                      <div className='col-4 mx-2 d-flex'>
                          <i className='ri-product-hunt-line pro' />
                          <div className='mx-2 mt-3'>
                            Producción
                          </div>
                      </div>
                  </div>
                </div>

              
              </div>
              
            }
          />
      </div> 


    </div>
  );
};

export default PersonalPorArea;
